/** Kurzer Toast unten zentriert (z. B. „Frage kopiert ✓"). */
import { signal } from "@preact/signals";

const text = signal<string>("");
const visible = signal<boolean>(false);
let timer: ReturnType<typeof setTimeout> | undefined;

export function showToast(message: string): void {
  text.value = message;
  visible.value = true;
  clearTimeout(timer);
  timer = setTimeout(() => (visible.value = false), 1700);
}

export function Toast() {
  return (
    <div class={`toast${visible.value ? " show" : ""}`} role="status" aria-live="polite">
      {text.value}
    </div>
  );
}
